// extracted by css-extract-rspack-plugin
export default {"helpTooltip":"JvQKcVdMPPU8oqap","helpIcon":"jCnFqdHryikmQGKr"};